import {Component, OnDestroy, OnInit} from '@angular/core';
import {TableService, VisitedService} from "@amlCore/services";
import {Subject} from 'rxjs';
import {takeUntil} from "rxjs/operators";
import {DictionariesService} from "../../../service/dictionaries.service";
import {TableController} from "@amlCore/tableController";
import {Utils} from "@amlCore/utils";
import {QrefOkwed2} from "../../../../../../api/build";

@Component({
  selector: 'app-dictionary-qrefokwed2',
  templateUrl: './qrefOkwed2.component.html'
})
export class QrefOkwed2Component extends TableController implements OnInit, OnDestroy {

  constructor(protected dictSrv: DictionariesService,
              protected visitedService: VisitedService,
              protected tableService: TableService
  ) {
    super(visitedService, tableService);
  }
  isShowVisited = false;
  isSetFocus = false;
  data: QrefOkwed2[] = [];
  public goBack = Utils.goBack;
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.loadDict();
  }

  loadDict() {
    this.dictSrv.getQrefOkwed2List().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.data = data.content;
    });
  }
  onPageChange(params): void {
    this.loadDict();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}


